// extracted by css-extract-rspack-plugin
export default {"relatedCreatorsWrapper":"_5d047eb7","relatedCreatorsHeader":"_94b6c9b","relatedCreators":"_f1492a04","viewMoreButton":"_aa886f4a"};